import { type ReactElement } from 'react'
import { type ComboboxOptionProps, Combobox, Group } from '@mantine/core'
import { ColorPrimitives } from '@front/model'
import { MaterialSymbolIcon } from '../terros'

export const SelectableOption = ({ selected, ...props }: ComboboxOptionProps): ReactElement => {
  return (
    <Combobox.Option {...props}>
      <Group justify='space-between'>
        <div className='flex-1'>{props.children}</div>
        {selected && <MaterialSymbolIcon icon='check' size='lg' color={ColorPrimitives.blue['500']} />}
      </Group>
    </Combobox.Option>
  )
}
